import { Component, OnInit, OnDestroy, HostListener } from "@angular/core";
import { TranslationService } from "./core/services/translation/translation.service";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { UserIdleService } from "angular-user-idle";
import { TimeoutComponent } from "./module/timeout/timeout.component";
import { MatDialogConfig, MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Spinkit } from "ng-http-loader";
import { ToastrService } from "ngx-toastr";
import { fromEvent, merge, of, Subscription } from "rxjs";
import { CrossTabIdleSyncService } from "./core/services/crossTabIdleSync.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  ispopup: boolean;
  counter: any;
  isConnected = false;
  hasNetworkConnection: boolean = false;
  hasInternetAccess: boolean = false;
  noInternetConnection: boolean = false;

  networkStatus: boolean = false;
  networkStatus$: Subscription = Subscription.EMPTY;

  public spinkit = Spinkit;
  constructor(
    private translationService: TranslationService,
    private router: Router,
    private userIdle: UserIdleService,
    private dialog: MatDialog,
    private toastrService: ToastrService,
    private idleSyncService: CrossTabIdleSyncService
  ) {
    // this.checkNetworkStatus();
    this.translationService.setAppLangOnStartup();
    this.ispopup = false;
  }

  @HostListener("document:mousemove")
  @HostListener("document:keydown")
  resetIdleTimer() {
    this.idleSyncService.updateLastActivity();
  }

  ngOnInit(): void {
    const route = this.router.url;
    if (
      localStorage.getItem("token") == null ||
      localStorage.getItem("token") === undefined
    ) {
      this.router.navigate(["/login"]);
    }
    // console.log(route);
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.translationService.setAppLangOnStartup();
    //Start watching for user inactivity.
    if (localStorage.getItem("token") != null && route != "/login") {
      this.userIdle.startWatching();
    }

    // // Start watching when user idle is starting.
    // this.userIdle.onTimerStart().subscribe((count) => {
    //   const token = localStorage.getItem("token");
    //   const currentUrl = this.router.url;
    //   this.counter = count;
    //   if (!this.ispopup && token != null && currentUrl != "/login") {
    //     this.timeout();
    //   }
    //   if (token == null && currentUrl == "/login") {
    //     this.stopWatching();
    //     this.stop();
    //   }
    // });
  }

  ngOnDestroy(): void {
    this.networkStatus$.unsubscribe();
  }

  stop(): any {
    this.userIdle.stopTimer();
  }

  stopWatching(): any {
    this.userIdle.stopWatching();
  }

  startWatching(): any {
    this.userIdle.startWatching();
  }

  restart(): any {
    this.userIdle.resetTimer();
  }

  confirmBox(): any {
    Swal.fire({
      title: "Are you sure want to remove?",

      text: "You will not be able to recover this file!",

      icon: "warning",

      showCancelButton: true,

      confirmButtonText: "Yes, delete it!",

      cancelButtonText: "No, keep it",
    }).then((result: any) => {
      if (result.value) {
        Swal.fire(
          "Deleted!",

          "Your imaginary file has been deleted.",

          "success"
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          "Cancelled",

          "Your imaginary file is safe :)",

          "error"
        );
      }
    });
  }

  confirm2(): any {
    let timerInterval: any;
    Swal.fire({
      title: "Auto close alert!",
      html: "I will close in <b></b> milliseconds.",
      timer: 2000,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
        // const b = Swal.getHtmlContainer().querySelector('b');
        // timerInterval = setInterval(() => {
        //   b.textContent = Swal.getTimerLeft();
        // }, 100);
      },
      willClose: () => {
        clearInterval(timerInterval);
      },
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === Swal.DismissReason.timer) {
        console.log("I was closed by the timer");
      }
    });
  }

  // timeout(): any {
  //   this.ispopup = true;
  //   const dialogConfig = new MatDialogConfig();

  //   dialogConfig.disableClose = true;
  //   dialogConfig.autoFocus = true;
  //   dialogConfig.data = {};
  //   const dialogref = this.dialog.open(TimeoutComponent, {
  //     width: "500px",
  //     height: "auto",
  //     autoFocus: true,
  //     disableClose: dialogConfig.disableClose,
  //     data: {
  //       counter: this.counter,
  //     },
  //   });

  //   dialogref.afterClosed().subscribe((result: any) => {
  //     this.ispopup = false;
  //   });
  // }

  reloadComponent(): any {
    // const currentUrl = this.router.url;
    const currentUrl = "login";
    console.log(currentUrl);
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate([currentUrl]);
  }
}
